import { mutator } from 'satcheljs';
import { updateWasSuggestionDisabled } from '../actions/publicActions';
import { getStore } from '../store/store';
import { workloadScenarioSettingsLoaded } from 'owa-scenario-settings';
import { getUserMailboxInfo } from 'owa-client-ids';

mutator(updateWasSuggestionDisabled, actionMessage => {
    getStore().wasSuggestionDisabled = actionMessage.wasDisabled;
});

mutator(workloadScenarioSettingsLoaded, actionMessage => {
    const { settings, userIdentity } = actionMessage;
    if (
        getUserMailboxInfo().userIdentity === userIdentity &&
        settings.wasFocusTimeSuggestionDisabled
    ) {
        getStore().wasSuggestionDisabled = settings.wasFocusTimeSuggestionDisabled;
    }
});
